module.exports = __webpack_public_path__ + "img/not-check-red-icon.2d9e9c24.svg";